import { authorizedAxios } from 'library/axios/apiProvider';
import { InsuranceFormState } from 'pages/AgentRemoteSale/components/InsuranceBox/types';

export async function installmentSelection(id: string, body: any): Promise<InsuranceFormState> {
  const { data } = await authorizedAxios().patch(`/api/v1/insurances-client/${id}/`, body);
  return data;
}
